var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M23 1.375H4A2.625 2.625 0 0 0 1.375 4v13A2.625 2.625 0 0 0 4 19.625h19A2.625 2.625 0 0 0 25.625 17V4A2.625 2.625 0 0 0 23 1.375"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M20.94 7.75a2 2 0 1 0 0-4 2 2 0 0 0 0 4M2 12.83l5.41-7.08M19 19 7.41 5.75M12.82 11.42l2.71-2.84M23.65 18.5l-8.12-9.92"
})));
export default SvgImage;